import React from 'react';
import EasebuzzCallbackBase from './EasebuzzCallbackBase';

const EasebuzzFailure = () => <EasebuzzCallbackBase success={false} />;

export default EasebuzzFailure;
